<div class="my-4 flex items-center gap-x-2 h-[24px]">
  @if ((commonStateService.selectedItems$ | async)?.length) {
    Выбрано предзаказов:
    {{ (commonStateService.selectedItems$ | async)?.length }}
    <button
      (click)="commonStateService.clearSelectedItems()"
      tuiButton
      size="xs"
      appearance="flat"
    >
      Очистить
    </button>
  }
</div>

<ng-container *tuiLet="user$ | async as user">
  <ng-container *tuiLet="(users$ | async) ?? [] as users">
    <tui-accordion
      *tuiLet="commonStateService.selectedItemsMap$ | async as selected"
      [rounded]="false"
    >
      @for (
        preOrder of preparedPreOrders$ | async;
        track preOrder.original.id;
        let index = $index
      ) {
        <tui-accordion-item
          (appShiftClick)="
            $event.preventDefault();
            $event.stopPropagation();
            onShiftClick$.next(preOrder.original)
          "
          (appCtrlClick)="
            $event.stopPropagation(); onCtrlClick$.next(preOrder.original)
          "
          borders="top-bottom"
          [showArrow]="false"
          [class.selected]="selected?.has(preOrder.original.id ?? 0)"
        >
          <div
            class="flex gap-x-2 py-1.5 pr-1.5"
            (appCtrlClick)="
              $event.stopPropagation(); onCtrlClick$.next(preOrder.original)
            "
            (appShiftClick)="
              $event.preventDefault();
              $event.stopPropagation();
              onShiftClick$.next(preOrder.original)
            "
          >
            <div class="w-[40px] rounded-xl bg-purple-200 text-center">
              {{ index + 1 }}
            </div>
            <div
              class="w-[40px] flex items-center justify-center"
              *tuiLet="
                findUserById(users, preOrder.original.userId) as createdBy
              "
            >
              @if (preOrder.original.userId) {
                <app-avatar
                  [firstName]="createdBy?.firstName ?? ''"
                  [lastName]="createdBy?.lastName ?? ''"
                  [me]="user?.id === preOrder.original.userId"
                ></app-avatar>
              }
            </div>
            <div class="w-[230px] overflow-hidden disappearing">
              {{ preOrder.original.clientJson.name }}
            </div>

            <div class="w-[250px] overflow-hidden disappearing">
              {{ preOrder.original.clientAddressWithCoordinatesJson.address }}
            </div>
            <div
              class="w-[250px] overflow-hidden disappearing flex items-center"
            >
              {{ preOrder.original.farmJson.name }}
              @if (preOrder.original.farmJson.taxNonPayer) {
                <tui-svg
                  tuiHint="Неплательщик НДС"
                  class="text-red-500"
                  src="tuiIconDollarSign"
                ></tui-svg>
              }
            </div>

            <div class="w-[120px] overflow-hidden disappearing">
              {{ preOrder.computed.flowerTypeName }}
            </div>
            <div class="w-[45px] overflow-hidden disappearing">
              @if (preOrder.original.cold) {
                <tui-svg [src]="snowflakeUrl"></tui-svg>
              }
            </div>
            <div class="w-[150px] overflow-hidden disappearing">
              {{ preOrder.original.buyerCode }}
            </div>
            <div class="w-[150px] overflow-hidden disappearing">
              {{ preOrder.computed.packages }} BX
            </div>
            <div class="w-[150px] overflow-hidden disappearing">
              {{ preOrder.computed.places }}
            </div>
            <div class="w-[120px] overflow-hidden disappearing">
              {{ preOrder.original.expectedLoadingDate | date: 'dd.MM.yyyy' }}
            </div>
            <div class="w-150px flex gap-x-2 items-center">
              @if (preOrder.original.dataSentTo1C === false) {
                <tui-svg
                  tuiHint="Данные не были загружены в 1С"
                  class="text-red-500"
                  src="tuiIconAlertTriangle"
                ></tui-svg>
              }
              <button
                size="s"
                appearance="icon"
                (click)="
                  $event.stopPropagation();
                  copy$.next(preOrder.original.id ?? 0)
                "
                tuiIconButton
                icon="tuiIconCopy"
              ></button>
              <button
                size="s"
                appearance="icon"
                (click)="
                  $event.stopPropagation();
                  delete$.next(preOrder.original.id ?? 0)
                "
                tuiIconButton
                icon="tuiIconTrash"
              ></button>
              <tui-badged-content>
                @if (preOrder.original.attachmentId) {
                  <tui-badge-notification size="s" tuiSlot="top">
                    1
                  </tui-badge-notification>
                }
                <button
                  (click)="
                    $event.stopPropagation();
                    openAttachmentsDialog$.next({
                      preOrder: preOrder.original,
                      index
                    })
                  "
                  tuiIconButton
                  size="s"
                  icon="tuiIconPaperclip"
                ></button>
              </tui-badged-content>
            </div>
          </div>

          <ng-template tuiAccordionItemContent>
            <app-pre-order [preOrder]="preOrder.original"></app-pre-order>
          </ng-template>
        </tui-accordion-item>
      }
    </tui-accordion>
  </ng-container>
</ng-container>

<div class="my-4">
  <button size="s" icon="tuiIconPlus" tuiButton (click)="create$.next()">
    Добавить предзаказ
  </button>
</div>
